module.exports = __webpack_public_path__ + "img/security-stability-mobile.2a67a77f.jpg";